import { helpers, React, ts, ui } from '_core';

type ChartProps = {
  id: string;
  readOnly: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  title: string;
  subtitle?: string;
  setExternalEmbed: (_json: ts.types.analysis.EmbedChartData) => void;
};

const Chart = ({ id, readOnly, loadWidgetData, file, fullScreen, title, subtitle, setExternalEmbed }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [alert, setAlert] = React.useState<{ type: 'error' | 'warning'; message: string } | null>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({ data: { file } });
      if (response) setData(response.data);
    } catch (err) {
      setAlert({ type: 'error', message: helpers.parseApiError(err as ts.types.common.ApiError) });
    }
  };

  React.useEffect(() => {
    setData(null);
    setExternalEmbed(null);
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  if (data === null) return <ui.CenteredLoader label="Loading data..." />;

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={alert}
      exportTitle={title}
      exportSubTitle={subtitle}
      setExternalEmbed={setExternalEmbed}
      yAxisLabel="Turnover"
      xAxisLabel="Time"
    />
  );
};

export default Chart;
